import classNames from 'classnames';
import type { JSX } from 'react';
import CheckCircleFilled from '../../icons/CheckCircleFilled';
import Clear from '../../icons/Clear';
import styles from './styles/styles.module.scss';

type SwitchProps = {
  className?: string;
  disabled?: boolean;
  labelText: string;
  onChange: (selected: boolean) => void;
  selected?: boolean;
  width?: 'auto' | 'full';
  testId: string;
};

const Switch = ({ className, disabled, labelText, onChange, selected, width = 'auto', testId }: SwitchProps): JSX.Element => (
  <label className={classNames(styles.container, styles[width], disabled && styles.disabled, className)}>
    <span className={styles.label}>{labelText}</span>
    <input
      checked={selected}
      disabled={disabled}
      onChange={e => {
        onChange(e.target.checked);
      }}
      type="checkbox"
      data-testid={testId}
      aria-label={labelText}
    />
    <div className={styles.switch}>{selected ? <CheckCircleFilled color="currentColor" /> : <Clear color="currentColor" />}</div>
  </label>
);

export default Switch;
